import type {PublicMethodUtils} from '@wix/document-services-types'
import type {LayoutersPublicAPI} from '@wix/document-services-public-types'
import {layouters, utils} from '@wix/document-services-implementation'
import type {PublicModuleDeclaration} from '../../documentServicesInitialisation'

export default function (publicMethodUtils: PublicMethodUtils): PublicModuleDeclaration<LayoutersPublicAPI> {
    const {deprecate} = publicMethodUtils
    return {
        methods: {
            layouters: {
                getMasterChildren: publicMethodUtils.defineGetter(layouters.getMasterChildren),
                getNonMasterChildren: publicMethodUtils.defineGetter(layouters.getNonMasterChildren),
                isMasterChild: publicMethodUtils.defineGetter(layouters.isMasterChild),
                canBeMasterChild: publicMethodUtils.defineGetter(layouters.canBeMasterChild),
                getParentCompWithOverflowHidden: publicMethodUtils.defineGetter(
                    layouters.getParentCompWithOverflowHidden
                ),
                toggleMasterChild: deprecate(
                    publicMethodUtils.defineDataManipulationAction(layouters.toggleMasterChild, {
                        isUpdatingAnchors: utils.YES
                    }),
                    'This method is deprecated'
                )
            }
        }
    }
}
